(function () {
  var SUSP = { yok: 0, on: 1, cift: 2 };
  var ESIK = 5, TAVAN = 5;

  function rM(b) { return (b.jant * 25.4 / 2 + b.lastik * 25.4) / 1000; }

  function tuketim(b, a) {
    var lo, hi;
    if (b.cift) { lo = 12; hi = 26; }
    else if (b.kadro === 'moto') { lo = 10; hi = 21; }
    else if (b.lastik >= 4) { lo = 8; hi = 18; }
    else { lo = 6; hi = 14; }
    var t = lo, d = hi - lo;
    t += ({ asfalt: 0, bozuk: 0.18, stabilize: 0.42, arazi: 0.7 }[a.zemin] || 0) * d;
    t += ({ duz: 0, orta: 0.12, dik: 0.24 }[a.yokus] || 0) * d;
    if (a.agir === 'evet') t += 0.1 * d;
    return t;
  }
  function menzil(b, a) { return Math.round(b.wh / tuketim(b, a)); }
  function egim(b, a) {
    if (!b.nm) return null;
    var r = a.agir === 'evet' ? 120 : 85;
    return (b.nm / rM(b)) / ((b.kg + r) * 9.81);
  }

  function skor(b, a) {
    var s = 0, why = [], warn = [], eksik = 0, over = false;
    if (b.kullanim === 'offroad' && a.zemin && a.zemin !== 'arazi') return null;
    if (a.agir === 'evet' && b.maks && b.maks < 110) return null;
    if (a.tasima === 'sik') {
      if (!b.kat) return null;
      s += 22;
      if (b.kg <= 25) { s += 16; why.push(b.kg + ' kg — gamın en hafifi, düzenli kaldırmaya uygun'); }
      else if (b.kg <= 28) { s += 9; why.push(b.kg + ' kg — taşınabilir ağırlıkta'); }
      else { s -= 10; warn.push(b.kg + ' kg — sık kaldırmak için ağır'); }
    } else if (a.tasima === 'arasira') {
      if (b.kat) { s += 15; why.push('Katlanır — araç bagajına giriyor'); } else s -= 30;
    } else if (a.tasima === 'yok' && b.kat) s -= 3;

    if (a.zemin === 'asfalt') {
      if (b.lastik >= 4) { s -= 14; warn.push(b.lastik + '" fat lastik — düzgün asfaltta gereksiz ağırlık'); }
      else if (b.kullanim === 'sehir') { s += 11; why.push(b.lastik + '" lastik — asfaltta hafif ve hızlı'); }
      else s -= 4;
    } else if (a.zemin === 'bozuk') {
      if (b.lastik >= 2.3) { s += 9; why.push(b.lastik + '" lastik — parke ve kasiste konforlu'); }
      if (SUSP[b.susp] >= 1) s += 6;
    } else if (a.zemin === 'stabilize') {
      if (b.lastik >= 4) s += 12; else s -= 10;
      if (SUSP[b.susp] >= 1) s += 7; else warn.push('Süspansiyon yok — stabilize yolda sert');
    } else if (a.zemin === 'arazi') {
      if (b.lastik >= 4) { s += 15; why.push(b.lastik + '" geniş lastik'); } else s -= 30;
      if (SUSP[b.susp] >= 2) { s += 11; why.push('Çift süspansiyon'); }
      else if (SUSP[b.susp] === 1) s += 5;
      else warn.push('Süspansiyon yok');
    }

    if (a.yokus) {
      var g = egim(b, a);
      if (g === null) { eksik++; if (a.yokus === 'dik') warn.push('Tork verisi yok — tırmanma doğrulanmalı'); }
      else {
        var hedef = { duz: 0.07, orta: 0.11, dik: 0.15 }[a.yokus];
        if (g >= hedef) {
          s += a.yokus === 'dik' ? 20 : 10;
          if (a.yokus === 'dik') why.push('~%' + Math.round(g * 100) + ' eğim tırmanır (' + b.nmLabel + ')');
        } else {
          s -= Math.round((hedef - g) * 180);
          if (a.yokus === 'dik') warn.push('~%' + Math.round(g * 100) + ' eğim — dik yokuşta pedal desteği gerekir');
        }
      }
    }
    if (a.agir === 'evet' && b.maks >= 120) { s += 10; why.push(b.maks + ' kg sürücü limiti'); }

    if (a.mesafe) {
      var gun = { az: 12, orta: 25, uzun: 40, cok: 60 }[a.mesafe];
      var m = menzil(b, a), o = m / gun;
      if (o >= 1.6) { s += 14; why.push('Bu kullanımda ~' + m + ' km — günlük ' + gun + ' km için rahat'); }
      else if (o >= 1.15) { s += 9; why.push('Bu kullanımda ~' + m + ' km'); }
      else if (o >= 0.9) { s -= 6; warn.push('Bu kullanımda ~' + m + ' km — sınırda, ara şarj gerekebilir'); }
      else { s -= 22; warn.push('Bu kullanımda ~' + m + ' km — günlük ' + gun + ' km için yetersiz'); }
    }

    if (a.kadro === 'alcak') {
      if (b.kadro === 'step-thru') { s += 26; why.push('Alçak girişli step-thru kadro'); } else s -= 14;
    }

    if (a.butce) {
      var cap = { a: 45000, b: 55000, c: 70000, d: 1e9 }[a.butce];
      if (b.fiyat > cap) { over = true; s -= (b.fiyat - cap) / 4000; }
      else s += Math.min(8, (cap - b.fiyat) / 7000);
    }

    if (a.oncelik === 'hafif') { s += 42 - b.kg; if (b.kg <= 23) why.push('Gamın en hafifi'); }
    else if (a.oncelik === 'menzil') s += b.wh / 40;
    else if (a.oncelik === 'cekis') { var g2 = egim(b, a); if (g2 === null) eksik++; else s += g2 * 100; }
    else if (a.oncelik === 'donanim') {
      if (/idrolik/.test(b.fren)) { s += 8; why.push(b.fren); }
      s += SUSP[b.susp] * 4;
    }

    if (b.stok > 0 && b.stok <= 15) warn.push('Son adetler');
    return { s: s, why: why, warn: warn, eksik: eksik, over: over };
  }

  function sirala(a, bikes) {
    var r = [];
    for (var i = 0; i < bikes.length; i++) {
      var x = skor(bikes[i], a);
      if (x) r.push({ b: bikes[i], x: x });
    }
    r.sort(function (p, q) { return (p.x.over - q.x.over) || (q.x.s - p.x.s); });
    if (!r.length) return r;
    var tepe = r[0].x.s;
    r.forEach(function (t) {
      t.ayar = t.x.s;
      if (tepe - t.x.s <= ESIK && t.b.onc) {
        t.ayar = t.x.s + Math.max(-TAVAN, Math.min(TAVAN, t.b.onc / 25 * TAVAN));
      }
    });
    r.sort(function (p, q) { return (p.x.over - q.x.over) || (q.ayar - p.ayar); });
    return r;
  }

  function guven(o, ik) {
    var fark = ik ? o.x.s - ik.x.s : 99;
    if (o.x.eksik >= 2) return 'Veri eksik — servisle doğrulayın';
    if (o.x.eksik === 1) return 'İyi uyum · bazı teknik veriler eksik';
    if (fark >= 12) return 'Yüksek uyum';
    return 'İyi uyum · yakın alternatifler var';
  }

  window.AlbaAsistan = {
    sirala: sirala, guven: guven, skor: skor, menzil: menzil, egim: egim
  };
})();
